<div mat-dialog-title>
  <span class="mat-title" style="display: inline-block">
    Detalhes do candidato
  </span>

  <div class="controls" *ngIf="!readOnly">
    <button color="accent" mat-icon-button matTooltip="Rejeitar candidato" (click)="rejectCandidate()">
      <mat-icon>person_remove</mat-icon>
    </button>
    <button color="primary" mat-icon-button matTooltip="Selecionar candidato" (click)="addCandidate()">
      <mat-icon>post_add</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content>
  <mat-tab-group [selectedIndex]="1">
    <mat-tab label="Informações básicas">
      <form [formGroup]="form" style="margin-top: 20px">
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Primeiro nome</mat-label>
            <input type="text" matInput placeholder="Primero nome" formControlName="firstname" [readonly]="true" />
          </mat-form-field>
          <mat-form-field appearance="outline" [ngClass]="{ noselectable: hideCandidateData }">
            <mat-label>Sobrenome</mat-label>
            <input type="text" matInput placeholder="Sobrenome" formControlName="lastname" [readonly]="true"
              (select)="$event.preventDefault(); $event.stopPropagation()" />
          </mat-form-field>
        </div>

        <div class="row" [ngClass]="{ noselectable: hideCandidateData }">
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input type="email" matInput placeholder="Email" formControlName="email" [readonly]="true" />
            <button matSuffix mat-icon-button type="button" matTooltip="Enviar mensagem via email"
              *ngIf="!hideCandidateData" (click)="openEmail()">
              <mat-icon>email</mat-icon>
            </button>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Telefone</mat-label>
            <input type="phone" matInput placeholder="Telefone" formControlName="phone" [readonly]="true"
              mask="(00) 00000 0000" />
          </mat-form-field>
        </div>

        <div class="row" [ngClass]="{ noselectable: hideCandidateData }">
          <mat-form-field appearance="outline">
            <mat-label>Whatsapp</mat-label>
            <input type="phone" matInput placeholder="Whatsapp" formControlName="mobile" [readonly]="true"
              mask="(00) 00000 0000" />
            <button matSuffix mat-icon-button matTooltip="Enviar mensagem via whatsapp" *ngIf="!hideCandidateData"
              (click)="openWhatsapp()" style="color: green">
              <mat-icon>perm_phone_msg</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="row" [ngClass]="{ noselectable: hideCandidateData }">
          <mat-form-field appearance="outline">
            <mat-label>Data de aniversário</mat-label>
            <input type="date" matInput placeholder="Data de nascimento" formControlName="birthdate"
              [readonly]="true" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Idade</mat-label>
            <input
              matInput
              type="text"
              formControlName="age"
              [readonly]="true"
            /> 
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Sexo</mat-label>
            <input type="gender" matInput placeholder="Sexo" formControlName="gender" [readonly]="true" />
          </mat-form-field>
        </div>

        <fieldset>
          <legend>Outras informações</legend>

          <div class="row" [ngClass]="{ noselectable: hideCandidateData }">
            <mat-form-field appearance="outline">
              <mat-label>Cargo pretendido</mat-label>
              <input type="text" matInput placeholder="Cargo interesse" formControlName="desiredJobTitle"
                [readonly]="true" />
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Sobre o candidato</mat-label>
              <textarea matInput placeholder="Sobre o candidato" formControlName="aboutMe" rows="10"
                [readonly]="true"></textarea>
            </mat-form-field>
          </div>
        </fieldset>

        <fieldset>
          <legend>Localização</legend>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Estado</mat-label>
              <input type="text" matInput placeholder="Estado" formControlName="state" [readonly]="true" />
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Cidade</mat-label>
              <input type="text" matInput placeholder="Cidade" formControlName="city" [readonly]="true" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Bairro</mat-label>
              <input type="text" matInput placeholder="Bairro" formControlName="district" [readonly]="true" />
            </mat-form-field>
          </div>
        </fieldset>
      </form>
    </mat-tab>
    <mat-tab label="Experiências profissionais">
      <p class="mat-title">Esperiências profissionais</p>

      <ng-container *ngIf="(experiences$ | async)?.length === 0">
        <div class="empty-content">
          <span class="mat-body-2"> Nenhum curso encontrado </span>
        </div>
      </ng-container>

      <mat-accordion>
        <mat-expansion-panel mat-elevation-z3 style="margin: auto; width: 95%" hideToggle
          *ngFor="let experience of experiences$ | async">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span [innerHTML]="experience.office||experience.sinonimo"></span>
              <span *ngIf="experience.keywordsCount.params" class="badge-helper"
                [matBadge]="experience.keywordsCount.params" matBadgeColor="accent" matBadgeSize="small">
              </span>
              <span *ngIf="experience.keywordsCount.form" class="badge-helper"
                [matBadge]="experience.keywordsCount.form" matBadgeColor="primary" matBadgeSize="small">
              </span>
            </mat-panel-title>
            <mat-panel-description>
              <span [innerHTML]="experience.organization"></span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>
            de {{ experience.init_date | date : "dd/MM/yyyy" }} até
            {{ (experience.final_date | date : "dd/MM/yyyy") || "o momento" }}
          </p>
          <p matLine [innerHtml]="experience.description"></p>
        </mat-expansion-panel>
      </mat-accordion>
      <br />
      <br />
    </mat-tab>
    <mat-tab label="Escolaridade">
      <p class="mat-title">Escolaridade</p>

      <div class="education-level" *ngIf="levelEducation">
        <span class="mat-body-1">Nivel de escolaridade</span>
        <p class="mat-body-2">{{ levelEducation }}</p>
        <br />
      </div>

      <ng-container *ngIf="(educations$ | async)?.length === 0">
        <div class="empty-content">
          <span class="mat-body-2"> Nenhum curso encontrado </span>
        </div>
      </ng-container>

      <mat-list class="margin: 10px" *ngIf="(educations$ | async)?.length > 0">
        <ng-container *ngFor="let education of educations$ | async">
          <mat-list-item>
            <h3 matLine>
              {{ education.course_name }} - {{ education.institution_name }}
            </h3>
            <p matLine>
              <span>de {{ education.date_start | date : "dd/MM/yyyy" }} até
                {{
                (education.date_end | date : "dd/MM/yyyy") || "o momento"
                }}</span>
            </p>
          </mat-list-item>
        </ng-container>
      </mat-list>
    </mat-tab>
    <mat-tab label="Relatório de Compatibilidade" *ngIf = "useIA">
      <button
        mat-raised-button
        color="primary"
        (click)="getReport()"
        class="button_right"
        [disabled]="isLoading"
      >
        Gerar novo relatório
      </button>
      <div style="margin: 20px 0">
        <!-- Spinner e Mensagem de Carregamento -->
        <div *ngIf="isLoading" class="loading-container">
          <mat-progress-spinner
            [diameter]="30"
            color="primary"
            mode="indeterminate"
          ></mat-progress-spinner>
          <p class="loading-message">
            Carregando relatório, por favor aguarde...
          </p>
        </div>

        <!-- Exibir relatório quando não estiver carregando -->
        <p *ngIf="!isLoading && relatorio" [innerHtml]="relatorio"></p>

        <!-- Caso não haja relatório -->
        <p *ngIf="!isLoading && !relatorio" class="default-warning">
          Nenhum relatório encontrado.
        </p>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="warn" mat-dialog-close>Fechar</button>
</mat-dialog-actions>